<template>
    <div class="transfer-result">
        <div class="text-center">
            <div class="font-15">{{ newPointLabel }}</div>
            <div class="font-25">{{ FilterNumberFormat(newPoints) }}</div>
        </div>
        <div class="buttons">
            <PrimaryButton @click="onClickBack">
                {{ lbl.buttons.backToHome }}
            </PrimaryButton>
        </div>
    </div>
</template>
<script>
import Utility from "@/helper/Utility";
import { inject } from "vue";
import PrimaryButton from "../Button/PrimaryButton.vue";

export default {
    name: "TransferResult",
    components: {
        PrimaryButton,
    },
    inject: ["YesCoinStates", "TransferPointStates", "LandingStates"],
    mixins: [],
    emits: ["onClickBack"],
    data: function () {
        return {};
    },
    computed: {
        newPointLabel: function () {
            return Utility.stringFormat(this.lbl.result.new_point, this.blobConfig.appName)
        },
        blobConfig: function () {
            return this.LandingStates.appConfig
        },
        deductPoints: function () {
            return this.TransferPointStates.deductPoints
        },
        newPoints: function () {
            return this.YesCoinStates.userPoints.value
        }
    },
    setup: function () {
        const { lbl } = inject("LocaleStore")

        return {
            lbl
        }
    },
    mounted: function () { },
    methods: {
        onClickBack: function () {
            this.$emit("onClickBack")
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../style/base.scss";

.transfer-result {
    @extend %base-class;

    color: $gray;
    padding: 0px 36px 36px;

    .buttons {
        margin-top: 64px;
    }
}
</style>
